module.exports = __webpack_public_path__ + "img/grant_senior.874f71c7.png";